import { Component, OnInit  , ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { InstallmentchangeService } from "../shared/installmentchange.service";

@Component({
  selector: 'app-installmentchangelist',
  templateUrl: './installmentchangelist.component.html',
  styleUrls: ['./installmentchangelist.component.css']
})
export class InstallmentchangelistComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'LoanId', 'ChangeDate', 'InstallmentAmount', 'InstallmentOption', 'New'];

  changeList$ =[''];

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private installmentchangeService : InstallmentchangeService,
              private router: Router) { }

  ngOnInit() {
    this.getInstallmentChangeList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew()
  {
    this.router.navigate(['/installmentchange']);
  }

  getInstallmentChangeList(){
    this.installmentchangeService.FetchInstallmentChangeList().subscribe(data =>{
      this.dataSource.data =data;
    })
  }

  Edit(Loan : any){
    this.router.navigate(['/installmentchange', Loan.Id]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
